import { motion } from "framer-motion";
import { Sparkles, Target, MapPin } from "lucide-react";

const features = [
  { icon: Sparkles, title: "Doświadczenie", desc: "Wieloletni staż sceniczny i setki udanych wydarzeń" },
  { icon: Target, title: "Dopasowanie", desc: "Każdy występ dopasowany do charakteru Twojego wydarzenia" },
  { icon: MapPin, title: "Cała Polska", desc: "Działamy na terenie całego kraju z gwarancją jakości" },
];

export const About = () => {
  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-accent/20 to-transparent" />
      
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-accent font-semibold text-sm tracking-widest uppercase">Poznaj nas</span>
          <h2 className="text-4xl md:text-5xl font-montserrat font-bold mt-3 text-primary">
            O nas
          </h2>
        </motion.div>

        <div className="max-w-4xl mx-auto mb-16">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg text-center text-gray-600 leading-relaxed"
          >
            Jesteśmy zespołem profesjonalnych artystów z wieloletnim doświadczeniem scenicznym. 
            Specjalizujemy się w występach artystycznych dla firm i osób prywatnych, które 
            uświetniają każde wydarzenie i pozostają w pamięci na długo. Łączymy profesjonalizm 
            z kreatywnością, tworząc niezapomniane show.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 * i }}
                className="text-center p-8 rounded-2xl bg-secondary/50 hover:bg-secondary transition-colors group"
              >
                <div className="w-14 h-14 rounded-xl bg-accent/10 flex items-center justify-center mx-auto mb-5 group-hover:bg-accent/20 transition-colors">
                  <Icon className="w-7 h-7 text-accent" />
                </div>
                <h3 className="text-xl font-montserrat font-bold text-primary mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
